
import './commen-section.css';
import React from 'react'
import {Container} from 'reactstrap'; 

const CommenSection = (props) => {
  return (
    <section className='commen_section'>
        <Container>
            <h2 className='text-white'>{props.title}</h2>
        </Container>
    </section>
  )
}

export default CommenSection